export default "__VITE_ASSET__BEDH_Afh__"